export interface VendorActionTypes {
  type: VendorActions;
  payload?: any;
}

export enum VendorActions {
  CREATE_VENDOR = "CREATE_VENDOR",
  GET_VENDOR_LIST = "GET_VENDOR_LIST",
  SET_VENDOR_LIST = "SET_VENDOR_LIST",
  SET_VENDOR_LIST_PAGE_COUNT = "SET_VENDOR_LIST_PAGE_COUNT",
  GET_VENDOR_DATA_BY_ID = "GET_VENDOR_DATA_BY_ID",
  SET_VENDOR_DATA_BY_ID = "SET_VENDOR_DATA_BY_ID",
  EDIT_VENDOR_DATA_BY_ID = "EDIT_VENDOR_DATA_BY_ID",
}
